function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b78bfa3b-e4cf-406b-ba92-2c9af8fd3807",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-c0c3c0eb-7169-4507-b830-166cedc6232d",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 46,
    height: 46,
    rx: 8,
    ry: 8,
    style: {
      fill: "#181e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18,26.98c0-5.4,3.76-9.98,9.98-9.98s10.02,4.58,10.02,9.98-3.76,10.02-10.02,10.02-9.98-4.58-9.98-10.02Zm14.83,0c0-2.96-1.76-5.52-4.85-5.52s-4.81,2.56-4.81,5.52,1.72,5.56,4.81,5.56,4.85-2.56,4.85-5.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10,37V10h6v27h-6Z",
    style: {
      fill: "#c8095b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRed);
export default __webpack_public_path__ + "static/media/icon-red.e49cbb5ed817db79ff3af278f3c705cc.svg";
export { ForwardRef as ReactComponent };